import { useState } from "react";

export default function AuthLoginForm({ state, onChange, onSuccess, onError, authService }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const result = await authService.signIn(state.username, state.password);
      if (typeof onSuccess === "function") {
        // response for successful login
        onSuccess({ action: "authenticated", response: result });
      }
    } catch (err) {
      // TODO: implement various redirects etc we need
      // if (result.challengeName === 'NEW_PASSWORD_REQUIRED') {}
      if (err === "USER_NOT_CONFIRMED") {
        // redirect the user to the confirmation screen
        onSuccess({ action: "confirm", message: "Please confirm your account", response: err });
      } else {
        const errorMessage = err.message || "An error occurred during sign in";
        setError(errorMessage);

        if (typeof onError === "function") {
          onError(err);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const forgotPassword = async () => {
    if (typeof onSuccess === "function") {
      onSuccess({ action: "forgot" });
    }
  }

  return (
    <div className="mx-auto w-full max-w-md">
      <form onSubmit={handleSubmit} className="mb-4 rounded px-8 pt-6 pb-8">
        <h2 className="text-center">Sign In</h2>

        {error && (
          <div
            className="relative mt-4 mb-4 rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700"
            role="alert"
          >
            <span className="block sm:inline">{error}</span>
          </div>
        )}

        <div className="mb-4">
          <label className="mb-2 block text-sm font-bold" htmlFor="username">
            Username / Email
          </label>
          <input
            className="input-text"
            id="username"
            type="text"
            placeholder="Username or Email"
            value={state.username || ""}
            onChange={(e) => onChange("username", e.target.value)}
            autoComplete="username"
            required
          />
        </div>

        <div className="mb-6">
          <label className="mb-2 block text-sm font-bold text-gray-700" htmlFor="password">
            Password
          </label>
          <input
            className="input-text"
            id="password"
            type="password"
            placeholder="******************"
            value={state.password || ""}
            onChange={(e) => onChange("password", e.target.value)}
            autoComplete="current-password"
            required
          />
        </div>

        <div className="flex items-start justify-between">
          <a role="button" className="inline-block align-baseline font-bold text-sm text-proof-blue hover:opacity-80 cursor-pointer" onClick={forgotPassword}>
            Forgot Password?
          </a>
          <button
            className={`bg-proof-blue focus:shadow-outline rounded px-4 py-2 font-bold text-white hover:opacity-80 focus:outline-none ${loading ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
            type="submit"
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </div>
      </form>
    </div>
  );
}
